export function obtenerContenidoArchivo(file){    
    return new Promise(function(resolve,reject){
        obtenerByteArray(file).then(response => {        
             //const cadenaFinal = String.fromCharCode(...response.bytes);
             const cadenaFinal = response.data;             
             var blob = new Blob([cadenaFinal], { type: 'text/plain;charset=utf-8' });
             var fileOfBlob = null;
             if(isIE()){
                fileOfBlob=blob;
                fileOfBlob['name'] = response.nombre;     
                fileOfBlob['lastModifiedDate'] = Date.now();
             }else{
                fileOfBlob = new File([blob], response.nombre);
             }   
             resolve(fileOfBlob);
         }).catch(error => {
             reject(error);
         });   
    });
    
}

export function isIE (){
    return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
}

export function obtenerByteArray(file){
    return new Promise(function (resolve, reject){
        let objeto={};
        objeto.nombre=file.name;        
        obtenerTexto(file).then(response => {
            objeto.data=response;
            resolve(objeto);
        }).catch(error => {

        });
        // let reader = new FileReader();
        // let objeto={};
        // objeto.nombre=file.name;
        // let fileByteArray = [];
        // reader.readAsArrayBuffer(file);
        // reader.onloadend = function (evt) {
        //     if (evt.target.readyState === FileReader.DONE) {
        //        var arrayBuffer = evt.target.result,
        //            array = new Uint8Array(arrayBuffer);
        //        for (var i = 0; i < array.length; i++) {
        //            fileByteArray.push(array[i]);
        //         }
        //         objeto.bytes=fileByteArray;                
        //         resolve(objeto);
        //     }
        // }
    });
    
}

export function obtenerTexto(file, utf8 = true) {
    return new Promise(function (resolve, reject){
        const reader = new FileReader();
        reader.readAsText(file, utf8 ? 'UTF-8' : 'CP1252');
        reader.onload = () => {
            const result = reader.result;
            if (utf8 && result.includes('�')) {
                resolve(obtenerTexto(file, false));
            } else {
               resolve(result);
            }
        }
    });
    
}


export function formatoNombreArchivo(nombreArchivo){
    var strAccents = nombreArchivo.split('');
    var strAccentsOut = new Array();
    var strAccentsLen = strAccents.length;
    var accents =    "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëÇçðÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
    var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeCcdDIIIIiiiiUUUUuuuuNnSsYyyZz";
    for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) != -1) {
            strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else
            strAccentsOut[y] = strAccents[y];
    }
    strAccentsOut = strAccentsOut.join('');
    strAccentsOut=strAccentsOut.replace(/[-\s]/g, '_');//Cambiamos Guiones
    return strAccentsOut;
}